import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const opsgenieScheduleRedirectRoute: InvariantRoute = {
	name: 'opsgenie-schedule-redirect',
	path: '/projects/:projectKey',
	query: ['selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'],
};
